interface ApiErrorShapedResponse {
  data?: unknown
  errors?: unknown[]
  code?: unknown
}

function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

export function hasGraphqlOperationError(responseData: unknown) {
  if (!isObject(responseData)) return true

  const data = responseData as ApiErrorShapedResponse

  const hasGraphqlErrors = Array.isArray(data.errors) && data.errors.length > 0
  const hasBackendErrorCode = typeof data.code === 'string'
  const hasGraphqlDataField =
    'data' in data && data.data !== undefined && data.data !== null

  return hasGraphqlErrors || hasBackendErrorCode || !hasGraphqlDataField
}
